module.exports = __webpack_public_path__ + "static/add-new-5a87b70af144b390b9a542daf071291c.png";